import React from "react";
import { useTranslation } from "utilities/i18n";
import { ProtectedLink } from "TsRoleGuards";
import { NoResultsIndicatorAnimation } from "elements";
import { generatePath } from "polyrouter";
import { any, needs } from "rbac";
import { Guard } from "TsRoleGuards";
import { useTenantId } from "polyrouter/SelectedTenantProvider";

export const addDeviceRequirements = any([
  needs("register:device"),
  needs("UPDATE_TENANT")
]);

export const NoDevicesIndicator: React.FC = () => {
  const { t } = useTranslation();
  const tenantId = useTenantId();

  let PROVISIONING_PATH = "";
  if (tenantId) {
    PROVISIONING_PATH = generatePath(
      "/admin/accounts/details/:tenantId/provisioning",
      { tenantId }
    );
  }

  return (
    <NoResultsIndicatorAnimation title={t("NO_DEVICES")}>
      <div>
        <Guard requirement={addDeviceRequirements}>
          <p className="text-md mb-2">{t("NO_DEVICES_GET_STARTED")}</p>
        </Guard>
        <div className="controls">
          <ProtectedLink
            to={"/manage/register"}
            className="btn btn-primary"
            requirement="register:device"
          >
            {t("REGISTER_SINGLE_DEVICE")}
          </ProtectedLink>
          <ProtectedLink
            to={PROVISIONING_PATH}
            className="btn btn-primary"
            requirement="UPDATE_TENANT"
          >
            {t("PROVISION_MULTIPLE_DEVICES")}
          </ProtectedLink>
        </div>
      </div>
    </NoResultsIndicatorAnimation>
  );
};
